import { useState } from 'react';
import axios from 'axios';
import Layout from './Layout';
import '../styles.css';
import { API_URL } from '../config';

function Signup() {
  console.log('Rendering Signup - Full Version');
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [spouseName, setSpouseName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isVerificationSent, setIsVerificationSent] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleNext = async () => {
    console.log('Signup: handleNext called, step:', step);
    if (step === 1) {
      if (!email || !password || !confirmPassword) {
        setError('All fields are required');
        console.log('Signup: Validation error - missing fields');
        return;
      }
      if (!validateEmail(email)) {
        setError('Please enter a valid email address');
        console.log('Signup: Validation error - invalid email');
        return;
      }
      if (password !== confirmPassword) {
        setError('Passwords do not match');
        console.log('Signup: Validation error - passwords mismatch');
        return;
      }
      if (password.length < 8) {
        setError('Password must be at least 8 characters');
        console.log('Signup: Validation error - password too short');
        return;
      }
      if (!/[A-Z]/.test(password)) {
        setError('Password must include an uppercase letter');
        console.log('Signup: Validation error - no uppercase');
        return;
      }
      if (!/[0-9]/.test(password)) {
        setError('Password must include a number');
        console.log('Signup: Validation error - no number');
        return;
      }
      setError('');
      setStep(2);
    } else if (step === 2) {
      if (!spouseName) {
        setError('Please enter your spouse\'s name');
        console.log('Signup: Validation error - spouse name missing');
        return;
      }
      setError('');
      setStep(3);
    } else if (step === 3) {
      try {
        const response = await axios.post(`${API_URL}/api/signup`, {
          email,
          password,
        });
        console.log('Signup response:', response.data);
        setSuccess('Account created! Please check your email to verify your account.');
        setIsVerificationSent(true);
      } catch (err) {
        console.error('Signup error details:', err.response?.data, err.message, err.stack);
        setError(err.response?.data?.error || 'Signup failed');
      }
    }
  };

  const handleBack = () => {
    console.log('Signup: handleBack called, step:', step);
    setError('');
    setStep(step - 1);
  };

  const handleResendVerification = async () => {
    try {
      await axios.post(`${API_URL}/api/resend-verification`, { email });
      setSuccess('Verification email sent again! Please check your inbox.');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to resend verification email');
    }
  };

  if (isVerificationSent) {
    return (
      <Layout>
        <div className="signup-container">
        <h1>Check Your Email</h1>
        <div className="verification-message">
          <p>We've sent a verification email to <strong>{email}</strong></p>
          <p>Please click the link in the email to verify your account and start using True Devotion.</p>
          <p>Didn't receive the email?</p>
          <button onClick={handleResendVerification} className="resend-button">
            Resend Verification Email
          </button>
          <button onClick={() => window.location.href = '/login'} className="login-button">
            Back to Login
          </button>
        </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="signup-container">
      <h1>Sign Up for True Devotion</h1>
      <p className="progress">Step {step} of 3</p>
      {success && <p className="success">{success}</p>}
      {error && <p className="error">{error}</p>}
      {step === 1 && (
        <div className="step">
          <h2>Email & Password</h2>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
            required
          />
          <button onClick={handleNext}>Next</button>
        </div>
      )}
      {step === 2 && (
        <div className="step">
          <h2>Spouse Details</h2>
          <input
            type="text"
            value={spouseName}
            onChange={(e) => setSpouseName(e.target.value)}
            placeholder="Enter your spouse's name"
            required
          />
          <button onClick={handleBack}>Back</button>
          <button onClick={handleNext}>Next</button>
        </div>
      )}
      {step === 3 && (
        <div className="step">
          <h2>Complete Signup</h2>
          <p>Would you like to upgrade to a premium account for unlimited AI queries?</p>
          <button onClick={() => (window.location.href = '/upgrade')}>Upgrade Now</button>
          <button onClick={handleNext}>Skip & Complete</button>
          <button onClick={handleBack}>Back</button>
        </div>
      )}
      </div>
    </Layout>
  );
}

export default Signup;